// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__qHxpM","productName":"Table_productName__3CJdf"};